import { render, staticRenderFns } from "./EquityChangeDetails.vue?vue&type=template&id=9c2e120e"
import script from "./EquityChangeDetails.vue?vue&type=script&lang=js"
export * from "./EquityChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./EquityChangeDetails.vue?vue&type=style&index=0&id=9c2e120e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports